<template>
  <div v-show="isShow.isKVShow" class="pageKV">
    <div class="title scaleOut">
      <img src="./main-title.png" alt="" :style="{transform: `translate(${this.transX}px, ${this.transY}px)`}">
    </div>
    <div class="sakura1 sakura toRight">
      <img src="./sakura1.png" alt="" srcset="" class="toBottom">
    </div>
    <div class="sakura2 sakura toRight d1">
      <img src="./sakura2.png" alt="" srcset="" class="toBottom d1">
    </div>
    <div class="sakura3 sakura toRight d5">
      <img src="./sakura3.png" alt="" srcset="" class="toBottom d5">
    </div>
    <div class="sakura4 sakura toRight d3">
      <img src="./sakura1.png" alt="" srcset="" class="toBottom d3">
    </div>
    <div class="sakura5 sakura toRight d4">
      <img src="./sakura2.png" alt="" srcset="" class="toBottom d4">
    </div>
    <div class="sakura6 sakura toRight d5">
      <img src="./sakura3.png" alt="" srcset="" class="toBottom d5">
    </div>
    <button class="btn zoomOut" @click="showNext"></button>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: {
      type: Object
    }
  },
  data() {
    return {
      transX: 0,
      transY: 0
    }
  },
  methods: {
    showNext () {
      this.isShow.isKVShow = false;
      this.isShow.isTRShow = true;
      this.$emit('triggerTrans');
    }
  },
  mounted() {
    const maxX = 60;
    const maxY = 60;
    const _this = this;
    function handleMove(evt) {
      let x = evt.beta; // [-180, 180]
      let y = evt.gamma; // [-90, 90]

      if (x > 90) { x = 90 }
      if (x < -90) { x = -90 }

      x += 90;
      y += 90;
      _this.transY = (maxX * x / 180);
      _this.transX = (maxY * y / 180);
    }
    window.addEventListener('deviceorientation', handleMove, false);
  }
}
</script>

<style lang="less" scoped>
.pageKV {
  width: 100%;
  height: 100%;
  background-image: url(./main-bg.jpg);
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  .title {
    position: absolute;
    left: 50%;
    top: -1.25rem /* 20/16 */;
    width: 21.03125rem /* 336.5/16 */;
    height: 17.25rem /* 276/16 */;
    margin-left: -12.5rem;
    img {
      width: 100%;
    }
  }
  .sakura {
    position: absolute;
    width: .9375rem /* 15/16 */;
    height: .9375rem /* 15/16 */;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .sakura1 {
    top: 20%;
    left: 20%;
  }

  .sakura2 {
    top: 40%;
    left: 30%;
  }

  .sakura3 {
    top: 30%;
    left: 60%;
  }

  .sakura4 {
    top: 40%;
    left: 20%;
  }

  .sakura5 {
    top: 50%;
    left: 60%;
  }

  .sakura6 {
    top: 40%;
    left: 10%;
  }

  .d3 {
    animation-delay: 2.4s;
  }

  .d4 {
    animation-delay: 4s;
  }

  .d5 {
    animation-delay: 4.8s;
  }

  .btn {
    position: absolute;
    left: 50%;
    bottom: 16%;
    width: 9.28125rem /* 148.5/16 */;
    height: 3.40625rem /* 54.5/16 */;
    margin-left: -4.59375rem /* 73.5/16 */;
    padding: unset;
    border: unset;
    background-color: transparent;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(./main-btn.png);
  }
}

.zoomOut {
  animation: zoomOut .8s ease-in-out infinite;
  animation-fill-mode: both;
}

@keyframes zoomOut {
  from {
    transform: scale(1);
    transform-origin: center;
  }
  to {
    transform: scale(1.04);
    transform-origin: center;
  }
}

.scaleOut {
  animation: scaleOut .4s ease-in;
  animation-fill-mode: both;
  animation-delay: .4s;
}

@keyframes scaleOut {
  0% {
    transform-origin: 80% 100%;
    transform: scale(.2);
    opacity: 0
  }
  90% {
    transform-origin: 80% 100%;
    transform: scale(1.06);
    opacity: 1;
  }
  94%, 100% {
    transform-origin: 80% 100%;
    transform: scale(1);
    opacity: 1;
  }
}

.d1 {
  animation-delay: 1s;
}

.d2 {
  animation-delay: 1.4s;
}

.toBottom {
  animation: toBottom 3s linear infinite;
  animation-fill-mode: both;
}

.toRight {
  animation: toRight 3s ease-in-out infinite;
  animation-fill-mode: both;
}

@keyframes toBottom {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(43.75rem /* 700/16 */);
  }
}

@keyframes toRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(12.5rem /* 200/16 */);
  }
}
</style>
